import React, { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import { faXmark, faInfo } from "@fortawesome/pro-light-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Tooltip, TooltipContent, TooltipTrigger } from "../MyTooltip";

const ModalHorizon = (props) => {
    // const { isOpen, onClose } = useDisclosure();
    const {
        title,
        description,
        isOpen,
        onClose,
        btnVisible = true,
        onClickBtn = undefined,
        btnLabel = "Ok",
        btnDisabled = false,
        getIsBtnDisabled = null,
        hfull = false,
        info = null,
        content,
    } = props;
    const cancelButtonRef = useRef(null);
    return (
        <Transition.Root show={isOpen} as={Fragment}>
            <Dialog
                as="div"
                className="relative z-10"
                initialFocus={cancelButtonRef}
                onClose={() => {
                    onClose();
                }}
            >
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
                </Transition.Child>

                <div className="fixed inset-0 z-10 flex h-4/5 min-h-full w-full items-end justify-center place-self-center overflow-y-auto p-4 text-center sm:items-center sm:p-0 lg:w-1/2">
                    <Transition.Child
                        as={Fragment}
                        enter="ease-out duration-300"
                        enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                        enterTo="opacity-100 translate-y-0 sm:scale-100"
                        leave="ease-in duration-200"
                        leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                        leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    >
                        <Dialog.Panel
                            style={{
                                maxHeight: "85%",
                            }}
                            className={
                                (hfull ? "h-full " : "") +
                                "sm:min-w-72 relative flex transform flex-col justify-between overflow-hidden rounded-lg bg-white p-3 text-left shadow-xl transition-all sm:my-8 lg:max-w-[730px] " +
                                "overflow-y-auto px-[30px] pt-[35px] pb-[40px]"
                            }
                        >
                            <div className="flex w-full flex-row justify-between">
                                {info && (
                                    <div className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full">
                                        <Tooltip>
                                            <TooltipTrigger
                                                type="button"
                                                className={
                                                    "border-light-blue mx-auto flex h-4 w-4 flex-shrink-0 items-center justify-center rounded-full border"
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faInfo}
                                                    className={
                                                        "text-light-blue h-2 w-2"
                                                    }
                                                />
                                            </TooltipTrigger>
                                            <TooltipContent className="Tooltip">
                                                <span className="text-wrap max-w-[20px]">
                                                    {info}
                                                </span>
                                            </TooltipContent>
                                        </Tooltip>
                                    </div>
                                )}
                                {title && (
                                    <h1 className="mb-[20px] text-2xl font-bold">
                                        {title}
                                    </h1>
                                )}
                                {!btnVisible && (
                                    <div className="flex flex-row self-center pb-[14px]">
                                        <button
                                            className="text-xs"
                                            onClick={() => {
                                                onClose();
                                            }}
                                        >
                                            <FontAwesomeIcon
                                                icon={faXmark}
                                                className="h-5 w-5"
                                            />
                                        </button>
                                    </div>
                                )}
                            </div>

                            <div className="mb-[20px] flex h-full flex-col overflow-y-auto">
                                <div className="flex h-full flex-col">
                                    <p
                                        className=""
                                        dangerouslySetInnerHTML={{
                                            __html: description,
                                        }}
                                    ></p>
                                </div>
                            </div>

                            {content && <div className="mb-10">{content}</div>}

                            {btnVisible ? (
                                <div className="grid grid-cols-1 gap-5 md:grid-cols-2">
                                    <button
                                        type="button"
                                        onClick={onClose}
                                        className="linear bg-transparent rounded-[8px] border border-brand-500 px-[24px] py-[8px] text-base font-bold uppercase text-brand-500 transition duration-200 hover:bg-brand-600 hover:text-white active:bg-brand-700 active:text-white dark:bg-brand-400 dark:text-brand-500 dark:hover:bg-brand-300 dark:hover:text-white dark:active:bg-brand-200 dark:active:text-white"
                                    >
                                        Chiudi
                                    </button>

                                    {btnLabel && onClickBtn ? (
                                        <button
                                            type="button"
                                            disabled={
                                                btnDisabled ||
                                                getIsBtnDisabled?.()
                                            }
                                            onClick={onClickBtn}
                                            className={`linear rounded-[8px] bg-brand-500 px-[24px] py-[8px] text-base font-bold uppercase text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 ${
                                                btnDisabled ||
                                                getIsBtnDisabled?.()
                                                    ? "pointer-events-none select-none opacity-60"
                                                    : ""
                                            }`}
                                        >
                                            {btnLabel}
                                        </button>
                                    ) : null}
                                </div>
                            ) : null}
                        </Dialog.Panel>
                    </Transition.Child>
                </div>
            </Dialog>
        </Transition.Root>
    );
};

export default ModalHorizon;
